import React from "react";
import FormControl from "../../components/formControl";
import CustomDropdown from "../../components/presentationals/CustomDropdown";
import { Button } from "@material-ui/core";
import config from "../../utils/config";
import Spinner from "../../components/presentationals/Spinner";
import Error from "../../components/Error/index";
import { timeStampFormat } from "../../utils/common";
import { makeStyles } from "@material-ui/core/styles";
import InnerIncentiveInfoView from "./InnerIncentiveInfoView";
import { Skeleton } from "@mui/material";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { TextField, Chip } from "@material-ui/core";
import CloseIcon from "@mui/icons-material/Close";
import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";
import dayjs from "dayjs";
import LoadingAutocomplete from "../../components/presentationals/LoadingAutocomplete";

const useStyles = makeStyles((theme) => ({
  container: {
    // margin: "10px",
    height: "26px",
    // width: "30px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "& > * + *": {
      marginLeft: theme.spacing(2),
    },
  },
}));

const PotentialIncentiveEarningsView = ({
  searchFields,
  setSearchFields,
  timestamp,
  distList,
  onRunClick,
  partnerName,
  potentialIncentiveEarningsObj,
  data,
  structuredData,
  csvDownloadHandler,
  csvLoading,
  loading,
  csvActive,
  dynamicHeaders,
  handleInfoClick,
  isModalOpen,
  selectedData,
  orgId,
  agentId,
  name,
  fetchInnerInfo,
  innerInfoData,
  showInner,
  setShowInner,
  incentiveInfoData,
  expandedTiles,
  setExpandedTiles,
  selectedTilesBySection,
  setSelectedTilesBySection,
  isInnerModalOpen,
  setIsInnerModalOpen,
  handleTileSelection,
  getHighestPriorityTile,
  getFilteredTilesForSection,
  getAvailableTilesForSection,
  toggleTileExpansion,
  filteredArray,
  show,
  partnerRoleType,
}) => {
  // Helper function to get structured data for a specific section and tile
  const getStructuredDataForTile = (sectionName, tileName) => {
    const dataKey = `${sectionName}_${tileName}`;
    return structuredData[dataKey];
  };

  // Helper function to create a unique key for inner details
  const getInnerDetailsKey = (sectionName, tileName, kpi) => {
    return `${sectionName}_${tileName}_${kpi}`;
  };

  const groupedData = potentialIncentiveEarningsObj?.modSecMasterTxDtos?.reduce(
    (acc, item) => {
      const category = item?.category;
      if (!acc[category] && item?.isSectionActive === "Y") acc[category] = [];
      acc[category]?.push(item);
      return acc;
    },
    {},
  );

  return (
    <>
      <div className="container-fluid">
        <div className="col-md-4">
          <h2 className="welcometxt">{`Welcome ${
            name !== "" ? name : orgId !== "" ? orgId : agentId
          } (${partnerName}) `}</h2>
        </div>
        {/* </div> */}
        {[
          "nhq",
          "region head",
          "state head",
          "jc",
          "area manager",
          "jpm",
        ].includes(partnerName?.toLowerCase()) ? (
          <div className="whitebox mt-2 mb-1">
            <form autoComplete="off">
              {partnerName?.toLowerCase() === "nhq" ? (
                <FormControl
                  variant="outlined"
                  type="form"
                  styleName="formControl"
                >
                  <CustomDropdown
                    name={"Region"}
                    data={config.region}
                    changeHandler={(value) =>
                      setSearchFields((prev) => ({
                        ...prev,
                        region: value,
                        state:
                          config?.states?.[
                            config?.regionMaps?.[value?.toUpperCase()]
                          ]?.[0],
                      }))
                    }
                    value={searchFields?.region}
                  />
                </FormControl>
              ) : null}
              {["nhq", "region head"].includes(partnerName.toLowerCase()) ? (
                <FormControl
                  variant="outlined"
                  type="form"
                  styleName="formControl"
                >
                  <CustomDropdown
                    name={"State"}
                    data={
                      config?.states?.[
                        config?.regionMaps?.[
                          searchFields?.region?.toUpperCase()
                        ]
                      ]
                    }
                    changeHandler={(value) =>
                      setSearchFields((prev) => ({
                        ...prev,
                        state: value,
                      }))
                    }
                    value={searchFields?.state}
                  />
                </FormControl>
              ) : null}
              {partnerName?.toLowerCase()?.includes("area") && (
                <FormControl
                  variant="outlined"
                  type="form"
                  styleName="formControl"
                >
                  <CustomDropdown
                    loading={distList?.loading}
                    name="JC"
                    data={filteredArray?.["JC"]}
                    changeHandler={(value) =>
                      setSearchFields((prev) => ({
                        ...prev,
                        jc: value,
                      }))
                    }
                    value={searchFields?.jc}
                  />
                </FormControl>
              )}

              {[
                "nhq",
                "region head",
                "state head",
                "jc",
                "jpm",
                "area manager",
              ].includes(partnerName.toLowerCase()) ? (
                distList?.loading ? (
                  <FormControl
                    variant="outlined"
                    type="form"
                    styleName="formControl"
                  >
                    <LoadingAutocomplete
                      loading={distList?.loading}
                      label={
                        partnerName?.toLowerCase()?.includes("area")
                          ? "RDS/ARD/MARD"
                          : "Partner Name"
                      }
                    />
                  </FormControl>
                ) : (
                  <FormControl
                    variant="outlined"
                    type="form"
                    styleName="formControl"
                  >
                    <CustomDropdown
                      name={
                        ["area", "jc", "jpm"].includes(
                          partnerName?.toLowerCase(),
                        )
                          ? "RDS/ARD/MARD"
                          : partnerRoleType?.toLowerCase()?.includes("jpm")
                            ? "JP"
                            : "Partner Names"
                      }
                      data={distList.data ?? []}
                      changeHandler={(value) =>
                        setSearchFields((prev) => ({
                          ...prev,
                          partner: value,
                        }))
                      }
                      value={searchFields?.partner ?? null}
                      {...(["nhq", "region head", "state head"].includes(
                        partnerName.toLowerCase(),
                      ) && { labelFieldName: "partnerName" })}
                    />
                  </FormControl>
                )
              ) : null}

              {partnerName?.toLowerCase() === "area" ? <></> : null}
              <FormControl
                variant="outlined"
                type="form"
                styleName="formControl"
              >
                <Button
                  type="button"
                  onClick={(e) => {
                    e.preventDefault();
                    onRunClick(searchFields);
                  }}
                  variant="contained"
                  color="default"
                  disabled={!distList?.data?.length}
                >
                  Run
                </Button>
              </FormControl>
            </form>
          </div>
        ) : null}
        <h2
          className="pagetitle wow fadeInUp"
          data-wow-delay=".5s"
          data-wow-duration="0.7s"
        >
          {(potentialIncentiveEarningsObj?.moduleName ?? "Scheme Performance") +
            ` (${dayjs().subtract(1, "day").format("MMMM YYYY")})`}
        </h2>
        <p
          className="text-muted mb-4 fw-bolder"
          style={{
            fontSize: "16px",
            color: "#6c757d",
          }}
        >
          Note:
          <br />
          <span className="text-danger">
            1. All values/figures shown here are indicative only. Actual
            values/figures may vary, subject to the conditions applicable for
            respective schemes.
          </span>
          <br />
          2. All values shown here are as per D-1 basis.
        </p>

        {loading ? (
          <Spinner />
        ) : show ? (
          potentialIncentiveEarningsObj &&
          potentialIncentiveEarningsObj.isModuleActive === "Y" && (
            <>
              {Object.entries(groupedData)?.length > 0 ? (
                Object.entries(groupedData)?.map(([category, rows]) => (
                  <div className="whitebox mb-3" key={category}>
                    <div className="subtitlebox">{category}</div>
                    {rows
                      ?.filter((row) => row?.isSectionActive === "Y")
                      ?.map((row, index) => {
                        return (
                          <div className="mb-3" key={index}>
                            <div
                              className="accordion"
                              id="accordionPanelsStayOpenExample"
                            >
                              <div className="accordion-item">
                                <h2
                                  className="accordion-header"
                                  id={`panelsStayOpen${row?.sectionId}`}
                                >
                                  <button
                                    className="accordion-button"
                                    style={{
                                      color: "#25326f",
                                      fontFamily: "jiotype-medium",
                                      fontSize: "18px",
                                    }}
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target={`#panelsStayOpen-${row?.sectionId}`}
                                    aria-expanded="true"
                                    aria-controls={`panelsStayOpen-${row?.sectionId}`}
                                  >
                                    {row?.sectionName}
                                  </button>
                                </h2>
                                <div
                                  id={`panelsStayOpen-${row?.sectionId}`}
                                  className="accordion-collapse collapse"
                                  aria-labelledby="panelsStayOpen-headingOne"
                                >
                                  <div className="accordion-body">
                                    {/* Show dropdown only when more than 2 items available */}
                                    {(() => {
                                      const availableTiles =
                                        getAvailableTilesForSection(row);

                                      const hasMoreThanTwoItems =
                                        availableTiles?.length >= 3;

                                      if (hasMoreThanTwoItems) {
                                        return (
                                          <div className="mt-2 mb-3">
                                            <Autocomplete
                                              multiple
                                              disableCloseOnSelect={
                                                window.innerWidth <= 768
                                              }
                                              id={`tile-select-${row?.sectionId}`}
                                              options={[
                                                {
                                                  tileName: "Select All",
                                                  isSelectAll: true,
                                                },
                                                ...availableTiles,
                                              ]}
                                              ref={(autocompleteRef) => {
                                                if (autocompleteRef) {
                                                  autocompleteRef.current =
                                                    autocompleteRef;
                                                }
                                              }}
                                              getOptionLabel={(option) =>
                                                option?.tileName
                                              }
                                              value={(() => {
                                                const highestPriorityTile =
                                                  getHighestPriorityTile(row);
                                                const currentSelection =
                                                  selectedTilesBySection[
                                                    row?.sectionId
                                                  ] || [];

                                                // Always include the highest priority tile in the value
                                                if (
                                                  highestPriorityTile &&
                                                  !currentSelection.some(
                                                    (tile) =>
                                                      tile.tileName ===
                                                      highestPriorityTile.tileName,
                                                  )
                                                ) {
                                                  return [
                                                    highestPriorityTile,
                                                    ...currentSelection,
                                                  ];
                                                }
                                                return currentSelection;
                                              })()}
                                              onChange={(event, newValue) => {
                                                // Check if "Select All" was selected
                                                const selectAllSelected =
                                                  newValue.some(
                                                    (option) =>
                                                      option.isSelectAll,
                                                  );

                                                if (selectAllSelected) {
                                                  // If "Select All" is selected, select all available tiles
                                                  const allTiles =
                                                    availableTiles.filter(
                                                      (tile) =>
                                                        !tile.isSelectAll,
                                                    );
                                                  handleTileSelection(
                                                    row?.sectionId,
                                                    allTiles,
                                                    row,
                                                  );
                                                } else {
                                                  handleTileSelection(
                                                    row?.sectionId,
                                                    newValue,
                                                    row,
                                                  );
                                                }
                                              }}
                                              filterOptions={(
                                                options,
                                                { inputValue },
                                              ) => {
                                                const highestPriorityTile =
                                                  getHighestPriorityTile(row);
                                                return options.filter(
                                                  (option) =>
                                                    option.tileName
                                                      .toLowerCase()
                                                      .includes(
                                                        inputValue.toLowerCase(),
                                                      ) &&
                                                    (option.isSelectAll ||
                                                      option.tileName !==
                                                        highestPriorityTile?.tileName),
                                                );
                                              }}
                                              renderOption={(
                                                option,
                                                { selected },
                                              ) => {
                                                if (option.isSelectAll) {
                                                  const currentSelection =
                                                    selectedTilesBySection[
                                                      row?.sectionId
                                                    ] || [];
                                                  const isAllSelected =
                                                    availableTiles
                                                      .filter(
                                                        (tile) =>
                                                          !tile.isSelectAll,
                                                      )
                                                      .every((tile) =>
                                                        currentSelection.some(
                                                          (selectedTile) =>
                                                            selectedTile.tileName ===
                                                            tile.tileName,
                                                        ),
                                                      );

                                                  return (
                                                    <>
                                                      <div
                                                        style={{
                                                          display: "flex",
                                                          alignItems: "center",
                                                          padding: "8px 0",
                                                          cursor: "pointer",
                                                        }}
                                                        onClick={(e) => {
                                                          e.stopPropagation();
                                                          if (isAllSelected) {
                                                            handleTileSelection(
                                                              row?.sectionId,
                                                              [],
                                                              row,
                                                            );
                                                          } else {
                                                            const allTiles =
                                                              availableTiles.filter(
                                                                (tile) =>
                                                                  !tile.isSelectAll,
                                                              );
                                                            handleTileSelection(
                                                              row?.sectionId,
                                                              allTiles,
                                                              row,
                                                            );
                                                          }
                                                        }}
                                                      >
                                                        {window.innerWidth <=
                                                          768 && (
                                                          <input
                                                            type="checkbox"
                                                            checked={
                                                              isAllSelected
                                                            }
                                                            onChange={(e) => {
                                                              e.stopPropagation();
                                                              if (
                                                                isAllSelected
                                                              ) {
                                                                handleTileSelection(
                                                                  row?.sectionId,
                                                                  [],
                                                                  row,
                                                                );
                                                              } else {
                                                                const allTiles =
                                                                  availableTiles.filter(
                                                                    (tile) =>
                                                                      !tile.isSelectAll,
                                                                  );
                                                                handleTileSelection(
                                                                  row?.sectionId,
                                                                  allTiles,
                                                                  row,
                                                                );
                                                              }
                                                            }}
                                                            style={{
                                                              cursor: "pointer",
                                                              marginRight:
                                                                "8px",
                                                              width: "18px",
                                                              height: "18px",
                                                            }}
                                                          />
                                                        )}

                                                        {option?.tileName}
                                                      </div>
                                                      {window.innerWidth <=
                                                        768 && (
                                                        <hr
                                                          style={{
                                                            margin: "18px 0",
                                                            borderColor:
                                                              "#e0e0e0",
                                                          }}
                                                        />
                                                      )}
                                                    </>
                                                  );
                                                }

                                                // Get eligibility value for this tile
                                                const tileData =
                                                  getStructuredDataForTile(
                                                    row?.sectionName,
                                                    option?.tileName,
                                                  );
                                                const tooltipEnabledField =
                                                  tileData?.data?.[
                                                    "ELIGIBILITY_TOOLTIP_ENABLED"
                                                  ];
                                                const eligibilityValue =
                                                  tileData?.data?.[
                                                    tooltipEnabledField
                                                  ];

                                                let dotColor = "#6c757d";
                                                if (
                                                  tooltipEnabledField &&
                                                  eligibilityValue
                                                ) {
                                                  if (
                                                    eligibilityValue.toLowerCase() ===
                                                    "yes"
                                                  ) {
                                                    dotColor = "#28a745";
                                                  } else if (
                                                    eligibilityValue.toLowerCase() ===
                                                    "no"
                                                  ) {
                                                    dotColor = "#dc3545";
                                                  }
                                                }

                                                const currentSelection =
                                                  selectedTilesBySection[
                                                    row?.sectionId
                                                  ] || [];
                                                const isSelected =
                                                  currentSelection.some(
                                                    (item) =>
                                                      item.tileName ===
                                                      option.tileName,
                                                  );

                                                return (
                                                  <div
                                                    style={{
                                                      opacity: 1,
                                                      fontWeight: "normal",
                                                      cursor: "pointer",
                                                      display: "flex",
                                                      alignItems: "center",
                                                      justifyContent:
                                                        "space-between",
                                                      width: "100%",
                                                      padding: "8px 0",
                                                    }}
                                                  >
                                                    <div
                                                      style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: "8px",
                                                        flex: 1,
                                                      }}
                                                    >
                                                      {window.innerWidth <=
                                                        768 && (
                                                        <input
                                                          type="checkbox"
                                                          checked={isSelected}
                                                          onChange={(e) => {
                                                            e.stopPropagation();
                                                            if (isSelected) {
                                                              const updatedSelection =
                                                                currentSelection.filter(
                                                                  (item) =>
                                                                    item.tileName !==
                                                                    option.tileName,
                                                                );
                                                              handleTileSelection(
                                                                row?.sectionId,
                                                                updatedSelection,
                                                                row,
                                                              );
                                                            } else {
                                                              const updatedSelection =
                                                                [
                                                                  ...currentSelection,
                                                                  option,
                                                                ];
                                                              handleTileSelection(
                                                                row?.sectionId,
                                                                updatedSelection,
                                                                row,
                                                              );
                                                            }
                                                          }}
                                                          onClick={(e) => {
                                                            e.stopPropagation();
                                                          }}
                                                          style={{
                                                            cursor: "pointer",
                                                            marginRight: "8px",
                                                            width: "18px",
                                                            height: "18px",
                                                          }}
                                                        />
                                                      )}
                                                      <div
                                                        style={{
                                                          width: "8px",
                                                          height: "8px",
                                                          borderRadius: "50%",
                                                          backgroundColor:
                                                            dotColor,
                                                          flexShrink: 0,
                                                        }}
                                                      />
                                                      {option?.tileName}
                                                    </div>
                                                    {window.innerWidth > 768 &&
                                                      isSelected && (
                                                        <CloseIcon
                                                          style={{
                                                            fontSize: "16px",
                                                            cursor: "pointer",
                                                            color: "#666",
                                                            marginLeft: "8px",
                                                          }}
                                                          onClick={(e) => {
                                                            e.stopPropagation();
                                                            const updatedSelection =
                                                              currentSelection.filter(
                                                                (item) =>
                                                                  item.tileName !==
                                                                  option.tileName,
                                                              );
                                                            handleTileSelection(
                                                              row?.sectionId,
                                                              updatedSelection,
                                                              row,
                                                            );
                                                          }}
                                                        />
                                                      )}
                                                  </div>
                                                );
                                              }}
                                              renderInput={(params) => {
                                                return (
                                                  <TextField
                                                    {...params}
                                                    variant="outlined"
                                                    label={`Select Criteria to View Details`}
                                                    placeholder="Choose..."
                                                  />
                                                );
                                              }}
                                              renderTags={(
                                                value,
                                                getTagProps,
                                              ) => {
                                                // Filter out "Select All" option
                                                const filteredValue =
                                                  value?.filter(
                                                    (option) =>
                                                      !option?.isSelectAll,
                                                  );

                                                // For mobile, show highest priority tile + count for others
                                                if (window.innerWidth <= 768) {
                                                  if (
                                                    filteredValue?.length === 0
                                                  ) {
                                                    return [];
                                                  }

                                                  const highestPriorityTile =
                                                    getHighestPriorityTile(row);
                                                  const highestPriorityInSelection =
                                                    filteredValue?.find(
                                                      (item) =>
                                                        item?.tileName ===
                                                        highestPriorityTile?.tileName,
                                                    );

                                                  const otherSelections =
                                                    filteredValue?.filter(
                                                      (item) =>
                                                        item?.tileName !==
                                                        highestPriorityTile?.tileName,
                                                    );

                                                  const chips = [];
                                                  if (
                                                    highestPriorityInSelection
                                                  ) {
                                                    const tileData =
                                                      getStructuredDataForTile(
                                                        row?.sectionName,
                                                        highestPriorityInSelection?.tileName,
                                                      );
                                                    const tooltipEnabledField =
                                                      tileData?.data?.[
                                                        "ELIGIBILITY_TOOLTIP_ENABLED"
                                                      ];
                                                    const eligibilityValue =
                                                      tileData?.data?.[
                                                        tooltipEnabledField
                                                      ];

                                                    let dotColor = "#6c757d"; // default gray
                                                    if (
                                                      tooltipEnabledField &&
                                                      eligibilityValue
                                                    ) {
                                                      if (
                                                        eligibilityValue.toLowerCase() ===
                                                        "yes"
                                                      ) {
                                                        dotColor = "#28a745"; // green
                                                      } else if (
                                                        eligibilityValue.toLowerCase() ===
                                                        "no"
                                                      ) {
                                                        dotColor = "#dc3545"; // red
                                                      }
                                                    }

                                                    chips.push(
                                                      <Chip
                                                        key="highest-priority"
                                                        label={
                                                          <div
                                                            style={{
                                                              display: "flex",
                                                              alignItems:
                                                                "center",
                                                              gap: "6px",
                                                            }}
                                                          >
                                                            <div
                                                              style={{
                                                                width: "6px",
                                                                height: "6px",
                                                                borderRadius:
                                                                  "50%",
                                                                backgroundColor:
                                                                  dotColor,
                                                                flexShrink: 0,
                                                              }}
                                                            />
                                                            {
                                                              highestPriorityInSelection?.tileName
                                                            }
                                                          </div>
                                                        }
                                                        style={{
                                                          backgroundColor:
                                                            "#e9ecef",
                                                          color: "#6c757d",
                                                          fontSize: "12px",
                                                          height: "24px",
                                                          cursor: "default",
                                                          margin: "2px",
                                                        }}
                                                        disabled={true}
                                                      />,
                                                    );
                                                  }

                                                  if (
                                                    otherSelections?.length > 0
                                                  ) {
                                                    chips.push(
                                                      <Chip
                                                        key="other-count"
                                                        label={
                                                          <div
                                                            style={{
                                                              display: "flex",
                                                              alignItems:
                                                                "center",
                                                              gap: "4px",
                                                            }}
                                                          >
                                                            <span>{`+${otherSelections?.length}`}</span>
                                                          </div>
                                                        }
                                                        style={{
                                                          backgroundColor:
                                                            "#e3f2fd",
                                                          color: "#1976d2",
                                                          fontSize: "12px",
                                                          height: "24px",
                                                          margin: "2px",
                                                        }}
                                                      />,
                                                    );
                                                  }

                                                  return chips;
                                                }

                                                // For desktop, show individual chips
                                                return filteredValue?.map(
                                                  (option, index) => {
                                                    const highestPriorityTile =
                                                      getHighestPriorityTile(
                                                        row,
                                                      );
                                                    const isHighestPriority =
                                                      option?.tileName ===
                                                      highestPriorityTile?.tileName;

                                                    // Get eligibility value for this tile
                                                    const tileData =
                                                      getStructuredDataForTile(
                                                        row?.sectionName,
                                                        option?.tileName,
                                                      );
                                                    const tooltipEnabledField =
                                                      tileData?.data?.[
                                                        "ELIGIBILITY_TOOLTIP_ENABLED"
                                                      ];
                                                    const eligibilityValue =
                                                      tileData?.data?.[
                                                        tooltipEnabledField
                                                      ];
                                                    let dotColor = "#6c757d"; // default gray
                                                    if (
                                                      tooltipEnabledField &&
                                                      eligibilityValue
                                                    ) {
                                                      if (
                                                        eligibilityValue.toLowerCase() ===
                                                        "yes"
                                                      ) {
                                                        dotColor = "#28a745"; // green
                                                      } else if (
                                                        eligibilityValue.toLowerCase() ===
                                                        "no"
                                                      ) {
                                                        dotColor = "#dc3545"; // red
                                                      }
                                                    }

                                                    return (
                                                      <Chip
                                                        label={
                                                          <div
                                                            style={{
                                                              display: "flex",
                                                              alignItems:
                                                                "center",
                                                              gap: "6px",
                                                            }}
                                                          >
                                                            <div
                                                              style={{
                                                                width: "6px",
                                                                height: "6px",
                                                                borderRadius:
                                                                  "50%",
                                                                backgroundColor:
                                                                  dotColor,
                                                                flexShrink: 0,
                                                              }}
                                                            />
                                                            {option?.tileName}
                                                          </div>
                                                        }
                                                        {...getTagProps({
                                                          index,
                                                        })}
                                                        key={option?.tileCode}
                                                        style={{
                                                          backgroundColor:
                                                            isHighestPriority
                                                              ? "#e9ecef"
                                                              : "#e3f2fd",
                                                          color:
                                                            isHighestPriority
                                                              ? "#6c757d"
                                                              : "#1976d2",
                                                          cursor: "pointer",
                                                          margin: "2px",
                                                          fontSize: "12px",
                                                          height: "24px",
                                                        }}
                                                        onDelete={
                                                          isHighestPriority
                                                            ? undefined
                                                            : getTagProps({
                                                                index,
                                                              }).onDelete
                                                        }
                                                      />
                                                    );
                                                  },
                                                );
                                              }}
                                              style={{ marginBottom: "15px" }}
                                            />
                                          </div>
                                        );
                                      }
                                      // For 2 or fewer items, don't show anything - tile details will be shown directly
                                      return null;
                                    })()}

                                    {getFilteredTilesForSection(row)?.length ===
                                    0 ? (
                                      <div className="text-center p-3">
                                        <p className="text-muted mb-0">
                                          No data available for this section.
                                        </p>
                                      </div>
                                    ) : (
                                      getFilteredTilesForSection(row)
                                        ?.sort(
                                          (a, b) => a?.priority - b?.priority,
                                        )
                                        ?.map((tile, index) => {
                                          const tileData =
                                            getStructuredDataForTile(
                                              row?.sectionName,
                                              tile?.tileName,
                                            );
                                          return tileData?.loading ? (
                                            <div
                                              className="row mb-4 "
                                              key={index}
                                            >
                                              <div className="">
                                                <Skeleton
                                                  key={index}
                                                  variant="rectangular"
                                                  width="100%"
                                                  height={150}
                                                />
                                              </div>
                                            </div>
                                          ) : tileData?.data ? (
                                            <div
                                              className="row mb-4 "
                                              key={index}
                                            >
                                              <div className="col-12">
                                                <style>
                                                  {`
                                            @media (min-width: 768px) and (max-width: 1023px) {
                                            .grad5 {
                                                width: 160px !important;
                                                height: 135px !important;
                                                min-width: 160px !important;
                                                max-width: 160px !important;
                                              }
                                              .tile-text {
                                                font-size: 14px !important;
                                              }
                                            }
                                            
                                            /* Mobile Card Styles */
                                            @media (max-width: 767px) {
                                              .mobile-card-container {
                                                display: block !important;
                                                padding: 0 8px;
                                              }
                                              .desktop-table-container {
                                                display: none !important;
                                              }
                                              
                                              /* Checkbox styling for mobile */
                                              .MuiAutocomplete-option input[type="checkbox"] {
                                                width: 16px !important;
                                                height: 16px !important;
                                                margin-right: 8px !important;
                                                cursor: pointer !important;
                                              }
                                              
                                              /* Select All option styling for mobile */
                                              .MuiAutocomplete-option hr {
                                                margin: 6px 0 !important;
                                                border-color: #e0e0e0 !important;
                                              }
                                              
                                              /* Show checkboxes on mobile */
                                              .MuiAutocomplete-option input[type="checkbox"] {
                                                display: block !important;
                                              }
                                              
                                              /* Hide separator on desktop */
                                              .MuiAutocomplete-option hr {
                                                display: none !important;
                                              }
                                              /* Scorecard styling for mobile */
                                              .mobile-cards-collapsible .card {
                                                box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                                                border-radius: 8px;
                                              }
                                              
                                              .mobile-cards-collapsible .card-header {
                                                border-radius: 8px 8px 0 0;
                                              }
                                              
                                              .mobile-cards-collapsible .card-body {
                                                border-radius: 0 0 8px 8px;
                                              }
                                              
                                              /* Mobile Tile Collapsible Styles */
                                              .mobile-tile-header {
                                                cursor: pointer;
                                                display: flex;
                                                justify-content: space-between;
                                                align-items: center;
                                                padding: 8px 12px;
                                                background: #f8f9fa;
                                                border: 1px solid #dee2e6;
                                                border-radius: 6px;
                                                margin-bottom: 8px;
                                                transition: all 0.2s ease;
                                              }
                                              
                                              .mobile-tile-header:hover {
                                                background: #e9ecef;
                                              }
                                              
                                              .mobile-tile-title {
                                                font-weight: 600;
                                                color: #495057;
                                                font-size: 14px;
                                              }
                                              
                                              .mobile-tile-expand-icon {
                                                transition: transform 0.2s ease;
                                                color: #6c757d;
                                                font-size: 12px;
                                              }
                                              
                                              .mobile-tile-expand-icon.expanded {
                                                transform: rotate(180deg);
                                              }
                                              
                                              .mobile-cards-collapsible {
                                                max-height: 0;
                                                overflow: hidden;
                                                transition: max-height 0.3s ease-out;
                                              }
                                              
                                              .mobile-cards-collapsible.expanded {
                                                max-height: 2000px;
                                                transition: max-height 0.3s ease-in;
                                              }
                                              
                                              /* Reduce tile spacing on mobile */
                                              .row.mb-4 {
                                                margin-bottom: 1rem !important;
                                              }
                                              
                                              /* Reduce accordion spacing on mobile */
                                              .m-3 {
                                                margin: 0.5rem !important;
                                              }
                                              
                                              /* More specific targeting for accordion items */
                                              .accordion .m-3 {
                                                margin: 0.25rem !important;
                                              }
                                              
                                              /* Reduce whitebox margins */
                                              .whitebox.mb-3 {
                                                margin-bottom: 1rem !important;
                                                padding: 0.75rem;
                                              }
                                              
                                              /* Reduce accordion body padding */
                                              .accordion-body {
                                                padding: 0.75rem !important;
                                              }
                                              
                                              /* Reduce tile gradient padding */
                                              .grad5 p {
                                                padding: 8px !important;
                                              }
                                              
                                              /* Main container adjustments */
                                              .container-fluid {
                                                padding-left: 10px !important;
                                                padding-right: 10px !important;
                                              }
                                              
                                              /* Welcome text adjustments */
                                              .welcometxt {
                                                font-size: 16px !important;
                                                margin-bottom: 0.5rem !important;
                                              }
                                              
                                              /* Page title adjustments */
                                              .pagetitle {
                                                font-size: 20px !important;
                                                margin-bottom: 1rem !important;
                                              }
                                              
                                              /* Subtitle box adjustments */
                                              .subtitlebox {
                                                padding: 0.5rem !important;
                                                margin-bottom: 0.5rem !important;
                                              }
                                              
                                              /* Note section adjustments */
                                              .whitebox span {
                                                font-size: 12px !important;
                                                padding: 0.5rem !important;
                                              }
                                              
                                              /* Button spacing adjustments */
                                              .btn {
                                                padding: 0.25rem 0.5rem !important;
                                                font-size: 12px !important;
                                              }
                                              
                                              /* Modal adjustments for mobile */
                                              .modal-body {
                                                padding: 0.75rem !important;
                                              }
                                              
                                              .modal-header {
                                                padding: 0.75rem !important;
                                              }
                                              
                                              .modal-footer {
                                                padding: 0.5rem !important;
                                              }
                                              
                                              /* Tile selector dropdown adjustments for mobile */
                                              .MuiAutocomplete-root {
                                                margin-bottom: 10px !important;
                                              }
                                              
                                              .MuiAutocomplete-inputRoot {
                                                font-size: 14px !important;
                                                min-height: 40px !important;
                                                max-height: 60px !important;
                                                overflow: hidden !important;
                                                padding: 4px 8px !important;
                                              }
                                              
                                              /* Ensure input field doesn't grow too tall */
                                              .MuiAutocomplete-inputRoot .MuiInputBase-input {
                                                padding: 4px 0 !important;
                                                font-size: 14px !important;
                                              }
                                              
                                              /* Mobile count chip styling */
                                              .MuiAutocomplete-inputRoot .MuiChip-root {
                                                font-size: 12px !important;
                                                height: 24px !important;
                                                margin: 2px !important;
                                              }
                                            }
                                            
                                            @media (min-width: 768px) {
                                              .mobile-card-container {
                                                display: none !important;
                                              }
                                              .desktop-table-container {
                                                display: block !important;
                                              }
                                              
                                              /* Desktop scorecard styling */
                                              .desktop-table-container .card {
                                                transition: transform 0.2s ease, box-shadow 0.2s ease;
                                                box-shadow: 0 2px 8px rgba(0,0,0,0.1);
                                                border-radius: 8px;
                                              }
                                              
                                              .desktop-table-container .card:hover {
                                                transform: translateY(-2px);
                                                box-shadow: 0 4px 12px rgba(0,0,0,0.15);
                                              }
                                              
                                              .desktop-table-container .card-header {
                                                border-radius: 8px 8px 0 0;
                                                border-bottom: 2px solid #dee2e6;
                                              }
                                              
              
                                              
                                              /* Individual metric card styling */
                                              .desktop-table-container .card .card {
                                                transition: all 0.3s ease;
                                                border: 1px solid #e9ecef;
                                              }
                                              
                                              .desktop-table-container .card .card:hover {
                                                transform: translateY(-1px);
                                                box-shadow: 0 4px 8px rgba(0,0,0,0.1);
                                                border-color: #dee2e6;
                                              }
                                              
                                              /* Responsive adjustments for metric cards */
                                              @media (max-width: 1199px) {
                                                .desktop-table-container .col-lg-4 {
                                                  margin-bottom: 1rem;
                                                }
                                              }
                                              
                                              @media (max-width: 767px) {
                                                .desktop-table-container .col-md-6 {
                                                  margin-bottom: 1rem;
                                                }
                                                
                                                .desktop-table-container .card .card-body {
                                                  padding: 0.75rem !important;
                                                }
                                              }
                                              
                                              /* Tile selector dropdown adjustments for desktop */
                                              .MuiAutocomplete-root {
                                                margin-bottom: 15px !important;
                                              }
                                              
                                              .MuiAutocomplete-inputRoot {
                                                font-size: 16px !important;
                                              }
                                              
                                              .MuiChip-root {
                                                font-size: 14px !important;
                                                height: 28px !important;
                                              }
                                              
                                              /* Desktop modal width adjustments */
                                              #innerDetailsModal .modal-dialog {
                                                width: 95% !important;
                                                max-width: 1400px !important;
                                              }
                                              
                                              /* Hide checkboxes on desktop */
                                              .MuiAutocomplete-option input[type="checkbox"] {
                                                display: none !important;
                                              }
                                              
                                              /* Show separator on desktop */
                                              .MuiAutocomplete-option hr {
                                                display: block !important;
                                                margin: 8px 0 !important;
                                                border-color: #e0e0e0 !important;
                                              }
                                              
                                              /* Prevent dropdown from closing on selection */
                                              .MuiAutocomplete-popper {
                                                z-index: 1300 !important;
                                              }
                                            }
                                          `}
                                                </style>
                                              </div>

                                              <div className="col-12 desktop-table-container">
                                                <div className="card border-secondary">
                                                  <div
                                                    className="card-header fw-bold"
                                                    style={{
                                                      backgroundColor:
                                                        "#CFD7F2",
                                                      color: "#25326f",
                                                      fontSize: "16px",
                                                      padding: "15px",
                                                      borderBottom:
                                                        "2px solid #dee2e6",
                                                    }}
                                                  >
                                                    <div className="d-flex justify-content-between align-items-center">
                                                      <div>{tile.tileName}</div>
                                                      <div className="d-flex align-items-center">
                                                        {(() => {
                                                          const tooltipEnabledField =
                                                            tileData?.data?.[
                                                              "ELIGIBILITY_TOOLTIP_ENABLED"
                                                            ];
                                                          const eligibilityValue =
                                                            tileData?.data?.[
                                                              tooltipEnabledField
                                                            ];
                                                          const isTooltipEnabled =
                                                            tooltipEnabledField !==
                                                            "NO";
                                                          const tooltipContent =
                                                            isTooltipEnabled
                                                              ? tileData
                                                                  ?.data?.[
                                                                  "ELIGIBILITY_TOOLTIP"
                                                                ] || ""
                                                              : "";
                                                          let bgColorClass = "";

                                                          if (
                                                            isTooltipEnabled
                                                          ) {
                                                            if (
                                                              eligibilityValue?.toLowerCase() ===
                                                              "yes"
                                                            ) {
                                                              bgColorClass =
                                                                "bg-success text-white";
                                                            } else if (
                                                              eligibilityValue?.toLowerCase() ===
                                                              "no"
                                                            ) {
                                                              bgColorClass =
                                                                "bg-danger text-white";
                                                            }
                                                          }

                                                          return (
                                                            eligibilityValue && (
                                                              <div
                                                                className={`fw-bold tooltip-test ${bgColorClass}`}
                                                                title={
                                                                  isTooltipEnabled
                                                                    ? tooltipContent
                                                                    : undefined
                                                                }
                                                                style={{
                                                                  cursor:
                                                                    isTooltipEnabled
                                                                      ? "pointer"
                                                                      : "default",
                                                                  padding:
                                                                    bgColorClass
                                                                      ? "6px 10px"
                                                                      : "6px 0",
                                                                  borderRadius:
                                                                    bgColorClass
                                                                      ? "30px"
                                                                      : "0",
                                                                  fontSize:
                                                                    "14px",
                                                                  minWidth:
                                                                    "60px",
                                                                  textAlign:
                                                                    "center",
                                                                }}
                                                              >
                                                                {eligibilityValue?.toLowerCase() ===
                                                                "yes"
                                                                  ? "Eligible"
                                                                  : "Not Eligible"}
                                                              </div>
                                                            )
                                                          );
                                                        })()}
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div className="">
                                                    <div className="row">
                                                      {Object.keys(
                                                        tileData?.data || {},
                                                      )
                                                        ?.filter(
                                                          (heading) =>
                                                            !heading
                                                              .toLowerCase()
                                                              .includes(
                                                                "tooltip",
                                                              ) &&
                                                            !heading
                                                              .toLowerCase()
                                                              .includes(
                                                                "inner",
                                                              ) &&
                                                            heading?.toLowerCase() !==
                                                              "eligibility",
                                                        )
                                                        .map((heading, i) => {
                                                          const value =
                                                            tileData?.data?.[
                                                              heading
                                                            ];
                                                          let bgColorClass = "";
                                                          let innerDetailsClass =
                                                            "";
                                                          const tooltipEnabledField =
                                                            tileData?.data?.[
                                                              "ELIGIBILITY_TOOLTIP_ENABLED"
                                                            ];
                                                          const isTooltipEnabled =
                                                            tooltipEnabledField ===
                                                            heading;
                                                          const tooltipContent =
                                                            isTooltipEnabled
                                                              ? tileData
                                                                  ?.data?.[
                                                                  "ELIGIBILITY_TOOLTIP"
                                                                ] || ""
                                                              : "";
                                                          if (
                                                            isTooltipEnabled
                                                          ) {
                                                            if (
                                                              value?.toLowerCase() ===
                                                              "yes"
                                                            ) {
                                                              bgColorClass =
                                                                "bg-success text-white";
                                                            } else if (
                                                              value?.toLowerCase() ===
                                                              "no"
                                                            ) {
                                                              bgColorClass =
                                                                "bg-danger text-white";
                                                            }
                                                          }

                                                          // Check if this heading has inner details
                                                          const hasInnerDetails =
                                                            tileData?.data?.[
                                                              "INNER_TILE_DETAILS"
                                                            ]?.some(
                                                              (item) =>
                                                                item?.INNER?.toLowerCase() ===
                                                                  "yes" &&
                                                                item?.KPI ===
                                                                  heading,
                                                            );

                                                          if (hasInnerDetails) {
                                                            innerDetailsClass =
                                                              "linkLikeClass";
                                                          }

                                                          return (
                                                            <div
                                                              className="col-lg-4 col-md-6 col-sm-12"
                                                              key={i}
                                                            >
                                                              <div className="h-100 border-0 ">
                                                                <div className="pt-2 pb-2">
                                                                  <div className="d-flex flex-column h-100 align-items-center">
                                                                    <div className="d-flex">
                                                                      {heading}
                                                                    </div>

                                                                    <div className="d-flex align-items-center">
                                                                      <div
                                                                        className={`align-items-center fw-bold ${
                                                                          isTooltipEnabled
                                                                            ? "tooltip-test"
                                                                            : ""
                                                                        } ${bgColorClass} ${innerDetailsClass}`}
                                                                        title={
                                                                          isTooltipEnabled
                                                                            ? tooltipContent
                                                                            : undefined
                                                                        }
                                                                        style={{
                                                                          cursor:
                                                                            isTooltipEnabled ||
                                                                            innerDetailsClass
                                                                              ? "pointer"
                                                                              : "default",
                                                                          padding:
                                                                            bgColorClass
                                                                              ? "8px 12px"
                                                                              : "8px 0",
                                                                          borderRadius:
                                                                            bgColorClass
                                                                              ? "6px"
                                                                              : "0",
                                                                          // fontSize:
                                                                          //   "16px",
                                                                          minWidth:
                                                                            "80px",
                                                                          textAlign:
                                                                            "center",
                                                                          flex: "1",
                                                                          // marginRight:
                                                                          //   "8px",
                                                                        }}
                                                                        onClick={
                                                                          innerDetailsClass
                                                                            ? () => {
                                                                                const key =
                                                                                  getInnerDetailsKey(
                                                                                    tileData?.sectionName,
                                                                                    tile.tileName,
                                                                                    heading,
                                                                                  );
                                                                                // Only fetch if not already loaded
                                                                                if (
                                                                                  showInner !==
                                                                                  key
                                                                                ) {
                                                                                  setShowInner(
                                                                                    key,
                                                                                  );
                                                                                  fetchInnerInfo(
                                                                                    {
                                                                                      url: tileData
                                                                                        ?.data
                                                                                        ?.INNER_TILE_DETAILS[
                                                                                        i
                                                                                      ]
                                                                                        ?.INNER_ENDPOINT,
                                                                                      sectionName:
                                                                                        tileData?.sectionName,
                                                                                      tileCode:
                                                                                        tileData?.tileCode,
                                                                                      kpi: heading,
                                                                                    },
                                                                                  );
                                                                                }
                                                                                // Open modal
                                                                                setIsInnerModalOpen(
                                                                                  true,
                                                                                );
                                                                              }
                                                                            : null
                                                                        }
                                                                      >
                                                                        {value}
                                                                      </div>

                                                                      {(() => {
                                                                        const downloadItem =
                                                                          tileData?.data?.[
                                                                            "INNER_TILE_DETAILS"
                                                                          ]?.find(
                                                                            (
                                                                              item,
                                                                            ) =>
                                                                              item?.CSV_DOWNLOAD?.toLowerCase() ===
                                                                                "yes" &&
                                                                              item?.KPI ===
                                                                                heading,
                                                                          );

                                                                        if (
                                                                          downloadItem
                                                                        ) {
                                                                          const loadingKey = `${tileData?.sectionName}_${tileData?.tileCode}_${heading}`;

                                                                          return (
                                                                            <div className="d-inline-block">
                                                                              {csvLoading?.[
                                                                                loadingKey
                                                                              ] ? (
                                                                                <Spinner
                                                                                  width="20px"
                                                                                  useStyles={
                                                                                    useStyles
                                                                                  }
                                                                                />
                                                                              ) : (
                                                                                <button
                                                                                  type="button"
                                                                                  className="btn btn-link btn-sm p-1"
                                                                                  onClick={() =>
                                                                                    csvDownloadHandler(
                                                                                      {
                                                                                        url: downloadItem?.CSV_DOWNLOAD_ENDPOINT,
                                                                                        sectionName:
                                                                                          tileData?.sectionName,
                                                                                        tileCode:
                                                                                          tileData?.tileCode,
                                                                                        kpi: heading,
                                                                                      },
                                                                                    )
                                                                                  }
                                                                                  title="Download CSV"
                                                                                >
                                                                                  <DownloadForOfflineIcon />
                                                                                </button>
                                                                              )}
                                                                            </div>
                                                                          );
                                                                        } else {
                                                                          return (
                                                                            <div
                                                                              className="d-inline-block"
                                                                              style={{
                                                                                width:
                                                                                  "41px",
                                                                                height:
                                                                                  "33px",
                                                                              }}
                                                                            ></div>
                                                                          );
                                                                        }
                                                                      })()}
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          );
                                                        })}
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>

                                              {/* Mobile Card View */}
                                              <div className="col-12 mobile-card-container">
                                                {/* Mobile Collapsible Header */}
                                                <div
                                                  className="mobile-tile-header d-md-none"
                                                  onClick={() =>
                                                    toggleTileExpansion(
                                                      `${tileData?.sectionName}_${tileData?.tileCode}`,
                                                    )
                                                  }
                                                >
                                                  <div className="d-flex justify-content-between align-items-center w-100">
                                                    <div className="mobile-tile-title">
                                                      {tileData?.tileName}
                                                    </div>
                                                    <div className="d-flex align-items-center">
                                                      {(() => {
                                                        const tooltipEnabledField =
                                                          tileData?.data?.[
                                                            "ELIGIBILITY_TOOLTIP_ENABLED"
                                                          ];
                                                        const eligibilityValue =
                                                          tileData?.data?.[
                                                            tooltipEnabledField
                                                          ];

                                                        if (eligibilityValue) {
                                                          let dotColor =
                                                            "#6c757d";
                                                          if (
                                                            eligibilityValue?.toLowerCase() ===
                                                            "yes"
                                                          ) {
                                                            dotColor =
                                                              "#28a745";
                                                          } else if (
                                                            eligibilityValue?.toLowerCase() ===
                                                            "no"
                                                          ) {
                                                            dotColor =
                                                              "#dc3545";
                                                          }

                                                          return (
                                                            <div
                                                              style={{
                                                                width: "10px",
                                                                height: "10px",
                                                                borderRadius:
                                                                  "50%",
                                                                backgroundColor:
                                                                  dotColor,
                                                                marginRight:
                                                                  "10px",
                                                              }}
                                                            />
                                                          );
                                                        }
                                                        return null;
                                                      })()}
                                                    </div>
                                                  </div>
                                                  <i
                                                    className={`fas fa-chevron-down mobile-tile-expand-icon ${
                                                      expandedTiles[
                                                        `${tileData?.sectionName}_${tileData?.tileCode}`
                                                      ]
                                                        ? "expanded"
                                                        : ""
                                                    }`}
                                                  ></i>
                                                </div>

                                                {/* Mobile Scorecard View - Collapsible */}
                                                <div
                                                  className={`mobile-cards-collapsible d-md-none ${
                                                    expandedTiles[
                                                      `${tileData?.sectionName}_${tileData?.tileCode}`
                                                    ]
                                                      ? "expanded"
                                                      : ""
                                                  }`}
                                                >
                                                  <div className="card border-secondary">
                                                    {/* <div
                                                    className="card-header text-center fw-bold"
                                                    style={{
                                                      backgroundColor:
                                                        "#CFD7F2",
                                                      color: "#25326f",
                                                      fontSize: "14px",
                                                      padding: "12px",
                                                      borderBottom:
                                                        "2px solid #dee2e6",
                                                    }}
                                                  >
                                                    {tile.tileName}
                                                  </div> */}
                                                    <div className="card-body p-0">
                                                      {Object.keys(
                                                        tileData?.data || {},
                                                      )
                                                        ?.filter(
                                                          (heading) =>
                                                            !heading
                                                              .toLowerCase()
                                                              .includes(
                                                                "tooltip",
                                                              ) &&
                                                            !heading
                                                              .toLowerCase()
                                                              .includes(
                                                                "inner",
                                                              ),
                                                        )
                                                        .map((heading, i) => {
                                                          const value =
                                                            tileData?.data?.[
                                                              heading
                                                            ];
                                                          let bgColorClass = "";
                                                          let innerDetailsClass =
                                                            "";
                                                          const tooltipEnabledField =
                                                            tileData?.data?.[
                                                              "ELIGIBILITY_TOOLTIP_ENABLED"
                                                            ];
                                                          const isTooltipEnabled =
                                                            tooltipEnabledField !==
                                                              "0" &&
                                                            tooltipEnabledField ===
                                                              heading;
                                                          const tooltipContent =
                                                            isTooltipEnabled
                                                              ? tileData
                                                                  ?.data?.[
                                                                  "ELIGIBILITY_TOOLTIP"
                                                                ] || ""
                                                              : "";
                                                          if (
                                                            isTooltipEnabled
                                                          ) {
                                                            if (
                                                              value?.toLowerCase() ===
                                                              "yes"
                                                            ) {
                                                              bgColorClass =
                                                                "bg-success text-white";
                                                            } else if (
                                                              value?.toLowerCase() ===
                                                              "no"
                                                            ) {
                                                              bgColorClass =
                                                                "bg-danger text-white";
                                                            }
                                                          }

                                                          // Check if this heading has inner details
                                                          const hasInnerDetails =
                                                            tileData?.data?.[
                                                              "INNER_TILE_DETAILS"
                                                            ]?.some(
                                                              (item) =>
                                                                item?.INNER?.toLowerCase() ===
                                                                  "yes" &&
                                                                item?.KPI ===
                                                                  heading,
                                                            );

                                                          if (hasInnerDetails) {
                                                            innerDetailsClass =
                                                              "linkLikeClass";
                                                          }

                                                          return (
                                                            <div
                                                              key={i}
                                                              className="border-bottom"
                                                              style={{
                                                                borderColor:
                                                                  "#dee2e6",
                                                                padding:
                                                                  "4px 8px",
                                                              }}
                                                            >
                                                              <div className="row align-items-center">
                                                                <div className="col-6">
                                                                  <div
                                                                    className="fw-bold text-muted"
                                                                    style={{
                                                                      fontSize:
                                                                        "13px",
                                                                    }}
                                                                  >
                                                                    {heading}
                                                                  </div>
                                                                </div>

                                                                <div className="col-6">
                                                                  <div className="d-flex align-items-center justify-content-around">
                                                                    <div
                                                                      className={`fw-bold ${
                                                                        isTooltipEnabled
                                                                          ? "tooltip-test"
                                                                          : ""
                                                                      } ${bgColorClass} ${innerDetailsClass}`}
                                                                      title={
                                                                        isTooltipEnabled
                                                                          ? tooltipContent
                                                                          : undefined
                                                                      }
                                                                      style={{
                                                                        cursor:
                                                                          isTooltipEnabled ||
                                                                          innerDetailsClass
                                                                            ? "pointer"
                                                                            : "default",
                                                                        padding:
                                                                          bgColorClass
                                                                            ? "6px 10px"
                                                                            : "6px 0",
                                                                        borderRadius:
                                                                          bgColorClass
                                                                            ? "4px"
                                                                            : "0",
                                                                        fontSize:
                                                                          "14px",
                                                                        minWidth:
                                                                          "60px",
                                                                        textAlign:
                                                                          "start",
                                                                        marginRight:
                                                                          "8px",
                                                                      }}
                                                                      onClick={
                                                                        innerDetailsClass
                                                                          ? () => {
                                                                              const key =
                                                                                getInnerDetailsKey(
                                                                                  tileData?.sectionName,
                                                                                  tile.tileName,
                                                                                  heading,
                                                                                );
                                                                              // Only fetch if not already loaded
                                                                              if (
                                                                                showInner !==
                                                                                key
                                                                              ) {
                                                                                setShowInner(
                                                                                  key,
                                                                                );
                                                                                fetchInnerInfo(
                                                                                  {
                                                                                    url: tileData
                                                                                      ?.data
                                                                                      ?.INNER_TILE_DETAILS[
                                                                                      i
                                                                                    ]
                                                                                      ?.INNER_ENDPOINT,
                                                                                    sectionName:
                                                                                      tileData?.sectionName,
                                                                                    tileCode:
                                                                                      tileData?.tileCode,
                                                                                    kpi: heading,
                                                                                  },
                                                                                );
                                                                              }
                                                                              // Open modal
                                                                              setIsInnerModalOpen(
                                                                                true,
                                                                              );
                                                                            }
                                                                          : null
                                                                      }
                                                                    >
                                                                      {value}
                                                                    </div>

                                                                    {(() => {
                                                                      const downloadItem =
                                                                        tileData?.data?.[
                                                                          "INNER_TILE_DETAILS"
                                                                        ]?.find(
                                                                          (
                                                                            item,
                                                                          ) =>
                                                                            item?.CSV_DOWNLOAD?.toLowerCase() ===
                                                                              "yes" &&
                                                                            item?.KPI ===
                                                                              heading,
                                                                        );

                                                                      if (
                                                                        downloadItem
                                                                      ) {
                                                                        const loadingKey = `${tileData?.sectionName}_${tileData?.tileCode}_${heading}`;

                                                                        return (
                                                                          <div>
                                                                            {csvLoading?.[
                                                                              loadingKey
                                                                            ] ? (
                                                                              <Spinner
                                                                                width="18px"
                                                                                useStyles={
                                                                                  useStyles
                                                                                }
                                                                              />
                                                                            ) : (
                                                                              <button
                                                                                type="button"
                                                                                className="btn btn-link btn-sm p-1"
                                                                                onClick={() =>
                                                                                  csvDownloadHandler(
                                                                                    {
                                                                                      url: downloadItem?.CSV_DOWNLOAD_ENDPOINT,
                                                                                      sectionName:
                                                                                        tileData?.sectionName,
                                                                                      tileCode:
                                                                                        tileData?.tileCode,
                                                                                      kpi: heading,
                                                                                    },
                                                                                  )
                                                                                }
                                                                                title="Download CSV"
                                                                              >
                                                                                <DownloadForOfflineIcon />
                                                                              </button>
                                                                            )}
                                                                          </div>
                                                                        );
                                                                      } else {
                                                                        return (
                                                                          <div
                                                                            style={{
                                                                              width:
                                                                                "41px",
                                                                              height:
                                                                                "33px",
                                                                            }}
                                                                          ></div>
                                                                        );
                                                                      }
                                                                    })()}
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          );
                                                        })}
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          ) : (
                                            <Error key={index} />
                                          );
                                        })
                                    )}

                                    <div>
                                      <button
                                        type="button"
                                        title="Info"
                                        className="btn tooltip-test"
                                        data-bs-toggle="modal"
                                        data-bs-target="#infoModal"
                                        onClick={() =>
                                          handleInfoClick(row.sectionName)
                                        }
                                        style={{ fontSize: "25px" }}
                                      >
                                        <i className="fa fa-info-circle"></i>
                                      </button>
                                    </div>
                                    {timestamp && (
                                      <div
                                        className="card-timestamp border-top mt-2"
                                        data-cy="card-timestamp"
                                      >
                                        <i className="fa fa-history mr-2 mt-2 mb-0"></i>
                                        Updated on
                                        {" " +
                                          timeStampFormat(
                                            timestamp?.[
                                              "Potential Incentive Earnings"
                                            ]?.[index]?.tileTimestamp,
                                          )}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                  </div>
                ))
              ) : (
                <div className="whitebox text-center">
                  <span>No active sections available.</span>
                </div>
              )}
            </>
          )
        ) : (
          <div
            className="whitebox wow fadeInUp text-center disclaimer p-4 rounded"
            data-wow-delay=".6s"
            data-wow-duration="0.7s"
          >
            {["nhq", "region head", "state head", "jc", "jpm", "area"].some(
              (word) => partnerName?.toLowerCase()?.includes(word),
            ) && (
              <ul>
                <li>Select the Partner Name from the dropdown and click RUN</li>
              </ul>
            )}
          </div>
        )}
      </div>
      <div
        className="modal fade"
        id="infoModal"
        tabIndex="-1"
        aria-labelledby="infoModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="infoModalLabel">
                Information
              </h5>
            </div>
            <div className="modal-body">
              {selectedData && Object.keys(selectedData || {})?.length > 0 ? (
                Object.entries(selectedData).map(
                  ([sectionName, sectionData]) => (
                    <div key={sectionName}>
                      <h5 className="text-center fw-bold">{sectionName}</h5>
                      <div style={{ overflowX: "auto", width: "100%" }}>
                        <table className="table table-bordered">
                          <thead className="table-dark">
                            <tr>
                              <th>Sr. No.</th>
                              <th>Range Min</th>
                              <th>Range Max</th>
                              <th>Range Value</th>
                            </tr>
                          </thead>
                          <tbody>
                            {sectionData.map((data, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{data.RANGE_MIN || "-"}</td>
                                <td>{data.RANGE_MAX || "-"}</td>
                                <td>
                                  {data.RANGE_VALUE_OPERATOR === "rs"
                                    ? "\u20B9" + " " + data.RANGE_VALUE
                                    : data.RANGE_VALUE +
                                      data.RANGE_VALUE_OPERATOR}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  ),
                )
              ) : (
                <p className="text-center">No Data Available</p>
              )}
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Inner Details Modal */}
      {isInnerModalOpen && (
        <div
          className="modal fade show"
          id="innerDetailsModal"
          tabIndex="-1"
          aria-labelledby="innerDetailsModalLabel"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div
            className="modal-dialog modal-xl"
            role="document"
            style={{ width: "95%", maxWidth: "1400px" }}
          >
            <div
              className="modal-content"
              style={{
                height: "90vh",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div className="modal-header" style={{ flexShrink: 0 }}>
                <h5
                  className=""
                  id="innerDetailsModalLabel"
                  style={{
                    textTransform: "uppercase",
                    color: "#6b696a",
                    fontSize: "22px",
                    fontFamily: "jiotype-medium",
                  }}
                >
                  Detailed Calculation Breakdown
                </h5>
                <button
                  type="button"
                  onClick={() => {
                    setIsInnerModalOpen(false);
                    setShowInner(null);
                  }}
                  className="btn-close"
                  aria-label="Close"
                  style={{
                    background: "none",
                    border: "none",
                    fontSize: "1.5rem",
                    cursor: "pointer",
                    padding: "0",
                    width: "30px",
                    height: "30px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  ×
                </button>
              </div>
              <div
                className="modal-body"
                style={{ flex: 1, overflowY: "auto" }}
              >
                {innerInfoData?.loading ? (
                  <div className="text-center p-4">
                    <Spinner />
                  </div>
                ) : innerInfoData?.error ? (
                  <div className="text-center p-4">
                    <Error />
                  </div>
                ) : innerInfoData?.data ? (
                  <InnerIncentiveInfoView
                    innerInfoData={innerInfoData?.data}
                    onClose={() => {
                      setIsInnerModalOpen(false);
                      setShowInner(null);
                    }}
                  />
                ) : (
                  <div className="text-center p-4">
                    <p>No data available</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      {/* )} */}
    </>
  );
};

export default PotentialIncentiveEarningsView;
